<template>
  <div
    class="roomie-overlay"
    :class="`${ customStyles ? customStyles : '' }`"
    @click.self="closeOverlay">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RoomieOverlay',
  props: {
    customStyles: {
      type: String,
      default: ''
    }
  },
  emits: ['overlay-closed'],
  methods: {
    closeOverlay() {
      this.$emit('overlay-closed')
    }
  }
}
</script>

<style
  lang="scss"
  src="./_index.scss">
</style>
